export interface Reference {
  referenceid: string,
  referencetype: string,
  referencename: string,
  noofparticipantsmax?: string,
  noofparticipantsmin?: string,
  points?: number,
}

